module.exports = __webpack_public_path__ + "img/drink_latte.e2ecfe1d.png";